import Swiper from 'swiper/dist/js/swiper';
import 'jquery';
import onDocumentReady from '../utilities/onDocumentReady';

onDocumentReady(() => new Swiper('.business-future-slider .swiper-container', {
    speed: 600,
    spaceBetween: 0,
    slidesRerView: 1,
    loop: true,
    pagination: {
        el: '.business-future-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.business-future-slider__button--next',
        prevEl: '.business-future-slider__button--prev',
    },
}));
